import { lazy, Suspense } from 'react';
import { DEFAULT_THUMBNAIL_STYLE, EARS_Z_INDEX, getAvatarViewLayerStyle, getLayeredHairThumbnailViewStyle, HAIR_THUMBNAIL_VIEWBOX, STANDARD_LAYER_VIEWBOX } from '../utils/LayoutUtils';

interface Props {
  option: number;
  colorBase: string;
  isThumbnail?: boolean;
  isHairThumbnail?: boolean;
}

const THUMBNAIL_VIEWBOX = "150 350 500 500";

const EarsLayer = ({ option, colorBase, isThumbnail, isHairThumbnail }: Props) => {
  let viewBox = isThumbnail ? THUMBNAIL_VIEWBOX : STANDARD_LAYER_VIEWBOX;

  let style = {};

  if (isThumbnail) {
    if (isHairThumbnail) {
      viewBox = HAIR_THUMBNAIL_VIEWBOX;
      style = getLayeredHairThumbnailViewStyle(EARS_Z_INDEX);
    } else {
      style = DEFAULT_THUMBNAIL_STYLE;
    }
  } else {
    style = getAvatarViewLayerStyle(EARS_Z_INDEX);
  }

  const componentName = `Ears0${option}`;
  const EarsComponent = lazy(() => import(`shared/components/avatar/ears/${componentName}`));

  return (
    <Suspense fallback={<div />}>
      <EarsComponent
        viewBoxProp={viewBox}
        colorBase={colorBase}
        style={style}
      />
    </Suspense>
  );
}

export default EarsLayer;
